import 'babel-polyfill';
import 'formdata-polyfill';

import { enUS, fi } from 'date-fns/locale';
import React from 'react';
import { registerLocale } from 'react-datepicker';
import { createRoot } from 'react-dom/client';
import { renderToStaticMarkup } from 'react-dom/server';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { initialize, addTranslationForLanguage } from 'react-localize-redux';

import 'bootstrap/dist/css/bootstrap.css';
import 'react-responsive-modal/styles.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-datepicker/dist/react-datepicker.css';

import localizationFi from './localization/fi.json';
import localizationEn from './localization/en.json';

import './fonts.css';
import './index.css';
import './components/forms/DatePicker.css';

import App from './App';
import store from './store';

registerLocale('en', enUS);
registerLocale('fi', fi);

const languages = {
  fi: localizationFi,
  en: localizationEn,
};

store.dispatch(initialize({
  languages: Object.keys(languages),
  options: { defaultLanguage: 'fi', renderToStaticMarkup },
}));

for (const language in languages) {
  store.dispatch(addTranslationForLanguage(languages[language], language));
}

const root = createRoot(document.getElementById('root'));
const router = createBrowserRouter([{
  path: '*',
  element: <App />,
}]);

root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);
